import { render, staticRenderFns } from "./OrderCheckoutInsuranceDocumentationSubmission.vue?vue&type=template&id=a356b004"
import script from "./OrderCheckoutInsuranceDocumentationSubmission.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutInsuranceDocumentationSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports